// import { useRef, useState, useEffect } from "react";
// import { ChevronLeft, ChevronRight } from "lucide-react";
// import { Link } from "react-router-dom";

// const services = [
//   {
//     title: "Pro Shop",
//     image:
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758578601/service_shop_baxptd.jpg",
//   },
//   {
//     title: "Restaurant",
//     image:
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758596543/restaurant_service_qby66d.jpg",
//   },
//   {
//     title: "Guest Retreat",
//     image:
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1763890719/WhatsApp_Image_2025-11-02_at_22.36.07_1_nrhf5j.jpg",
//   },
//   {
//     title: "Convention Hall",
//     image:
//       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755116270/Screenshot_2025-08-13_231504-min_ctap5h.png",
//   },
// ];

// const Services = () => {
//   const scrollRef = useRef(null);
//   const [showLeftArrow, setShowLeftArrow] = useState(false);
//   const [showRightArrow, setShowRightArrow] = useState(false);

//   const checkScrollPosition = () => {
//     if (scrollRef.current) {
//       const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
//       setShowLeftArrow(scrollLeft > 0);
//       setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
//     }
//   };

//   const scroll = (direction) => {
//     if (scrollRef.current) {
//       const scrollAmount = 320;
//       scrollRef.current.scrollBy({
//         left: direction === "left" ? -scrollAmount : scrollAmount,
//         behavior: "smooth",
//       });
//     }
//   };

//   useEffect(() => {
//     const currentRef = scrollRef.current;
//     currentRef?.addEventListener("scroll", checkScrollPosition);
//     window.addEventListener("resize", checkScrollPosition);
//     checkScrollPosition();

//     return () => {
//       currentRef?.removeEventListener("scroll", checkScrollPosition);
//       window.removeEventListener("resize", checkScrollPosition);
//     };
//   }, []);

//   return (
//     <section className="bg-[#fffdf6] py-16 px-4 md:px-20 relative">
//       <div className="max-w-7xl mx-auto relative">
//         <div className="text-center mb-10">
//           <h2 className="text-4xl font-bold text-black uppercase">
//             Our Services
//           </h2>
//         </div>

//         <div className="relative">
//           {/* Left Arrow */}
//           {showLeftArrow && (
//             <button
//               onClick={() => scroll("left")}
//               className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white shadow-lg rounded-full p-2 z-10 hover:bg-gray-100"
//               aria-label="Scroll left"
//             >
//               <ChevronLeft size={24} />
//             </button>
//           )}

//           {/* Scrollable Container */}
//           <div
//             ref={scrollRef}
//             className="flex overflow-x-auto gap-6 pb-4 scrollbar-hide scroll-smooth"
//             style={{ scrollBehavior: "smooth" }}
//           >
//             {services.map((service, index) => (
//               <div
//                 key={index}
//                 className="flex flex-col rounded-2xl overflow-hidden shadow-lg group flex-shrink-0 w-[300px]"
//               >
//                 <div className="h-72 w-full overflow-hidden">
//                   <img
//                     src={service.image}
//                     alt={service.title}
//                     className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
//                   />
//                 </div>

//                 {/* Service Links */}
//                 {service.title === "Restaurant" ? (
//                   <Link
//                     to="/restaurant"
//                     className="bg-lime-400 flex justify-between items-center p-4 font-semibold text-black text-lg hover:bg-lime-500 transition-colors duration-200"
//                   >
//                     <span>{service.title}</span>
//                     <span className="text-xl">→</span>
//                   </Link>
//                 ) : service.title === "Pro Shop" ? (
//                   <Link
//                     to="/pro-shop"
//                     className="bg-lime-400 flex justify-between items-center p-4 font-semibold text-black text-lg hover:bg-lime-500 transition-colors duration-200"
//                   >
//                     <span>{service.title}</span>
//                     <span className="text-xl">→</span>
//                   </Link>
//                 ) : service.title === "Guest Room" ? (
//                   <Link
//                     to="/guest-room"
//                     className="bg-lime-400 flex justify-between items-center p-4 font-semibold text-black text-lg hover:bg-lime-500 transition-colors duration-200"
//                   >
//                     <span>{service.title}</span>
//                     <span className="text-xl">→</span>
//                   </Link>
//                 ) : service.title === "Convention Hall" ? (
//                   <Link
//                     to="/convention-hall"
//                     className="bg-lime-400 flex justify-between items-center p-4 font-semibold text-black text-lg hover:bg-lime-500 transition-colors duration-200"
//                   >
//                     <span>{service.title}</span>
//                     <span className="text-xl">→</span>
//                   </Link>
//                 ) : (
//                   <div className="bg-lime-400 flex justify-between items-center p-4 font-semibold text-black text-lg">
//                     <span>{service.title}</span>
//                     <span className="text-xl">→</span>
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>

//           {/* Right Arrow */}
//           {showRightArrow && (
//             <button
//               onClick={() => scroll("right")}
//               className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white shadow-lg rounded-full p-2 z-10 hover:bg-gray-100"
//               aria-label="Scroll right"
//             >
//               <ChevronRight size={24} />
//             </button>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Services;

import { useRef, useState, useEffect } from "react";
import {
  ChevronLeft,
  ChevronRight,
  Sparkles,
  ArrowRight,
  Star,
  Coffee,
  ShoppingBag,
  BedDouble,
  Users,
} from "lucide-react";
import { Link } from "react-router-dom";

const services = [
  {
    title: "Pro Shop",
    image:
      "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758578601/service_shop_baxptd.jpg",
    icon: <ShoppingBag className="w-6 h-6" />,
    description: "Premium golf equipment and accessories",
    link: "/pro-shop",
    color: "from-emerald-500 to-emerald-400",
    bg: "bg-emerald-50",
    border: "border-emerald-100",
  },
  {
    title: "Restaurant",
    image:
      "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758596543/restaurant_service_qby66d.jpg",
    icon: <Coffee className="w-6 h-6" />,
    description: "Fine dining with scenic views",
    link: "/restaurant",
    color: "from-amber-500 to-amber-400",
    bg: "bg-amber-50",
    border: "border-amber-100",
  },
  {
    title: "Guest Retreat",
    image:
      "https://res.cloudinary.com/dxdvcplbl/image/upload/v1763890719/WhatsApp_Image_2025-11-02_at_22.36.07_1_nrhf5j.jpg",
    icon: <BedDouble className="w-6 h-6" />,
    description: "Luxurious accommodation for members",
    link: "/guest-room",
    color: "from-blue-500 to-blue-400",
    bg: "bg-blue-50",
    border: "border-blue-100",
  },
  {
    title: "Convention Hall",
    image:
      "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755116270/Screenshot_2025-08-13_231504-min_ctap5h.png",
    icon: <Users className="w-6 h-6" />,
    description: "Elegant venue for events and meetings",
    link: "/convention-hall",
    color: "from-purple-500 to-purple-400",
    bg: "bg-purple-50",
    border: "border-purple-100",
  },
];

const Services = () => {
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const servicesRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (servicesRef.current) {
        servicesRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 1000);
  });

  const checkScrollPosition = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);

      // Calculate active index based on scroll position
      const itemWidth = scrollRef.current.children[0]?.offsetWidth || 0;
      const scrollIndex = Math.round(scrollLeft / itemWidth);
      setActiveIndex(scrollIndex);
    }
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 400;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const scrollToIndex = (index) => {
    if (scrollRef.current) {
      const itemWidth = scrollRef.current.children[0]?.offsetWidth || 0;
      const scrollPosition = itemWidth * index;
      scrollRef.current.scrollTo({
        left: scrollPosition,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const currentRef = scrollRef.current;
    currentRef?.addEventListener("scroll", checkScrollPosition);
    window.addEventListener("resize", checkScrollPosition);
    checkScrollPosition();

    return () => {
      currentRef?.removeEventListener("scroll", checkScrollPosition);
      window.removeEventListener("resize", checkScrollPosition);
    };
  }, []);

  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-gradient-to-br from-emerald-50 via-white to-lime-50 relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-emerald-100 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute -bottom-24 -left-24 w-72 h-72 bg-lime-100 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute top-1/3 left-10 w-20 h-20 bg-emerald-200 rounded-full opacity-10"></div>
        <div className="absolute bottom-1/3 right-10 w-16 h-16 bg-lime-200 rounded-full opacity-10"></div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-30"></div>
              <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 border-2 border-emerald-100 flex items-center justify-center shadow-lg">
                <Star className="w-10 h-10 text-emerald-600" />
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3 mb-4">
            <Sparkles className="w-5 h-5 text-emerald-500" />
            <p className="text-sm font-semibold tracking-widest text-emerald-600 uppercase">
              Premium Amenities
            </p>
            <Sparkles className="w-5 h-5 text-emerald-500" />
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4">
            Our Exclusive{" "}
            <span className="relative inline-block">
              <span className="relative z-10 bg-gradient-to-r from-emerald-600 to-lime-600 bg-clip-text text-transparent">
                Services
              </span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-emerald-300 to-lime-300 opacity-40 -rotate-1"></span> */}
            </span>
          </h2>

          <p className="text-gray-600 text-lg md:text-xl max-w-3xl mx-auto">
            Experience unparalleled luxury and convenience with our world-class
            amenities designed for the discerning golfer
          </p>
        </div>

        {/* Services Slider Container */}
        <div ref={servicesRef} className="relative">
          {/* Left Arrow */}
          {showLeftArrow && (
            <button
              onClick={() => scroll("left")}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-6 md:-translate-x-8 bg-white/90 backdrop-blur-sm shadow-2xl rounded-full p-3 z-20 hover:bg-white transition-all duration-300 group hover:scale-110 border border-gray-200"
              aria-label="Scroll left"
            >
              <ChevronLeft className="w-6 h-6 text-gray-700 group-hover:text-emerald-600 transition-colors" />
            </button>
          )}

          {/* Scrollable Services Cards */}
          <div
            ref={scrollRef}
            className="flex overflow-x-auto gap-8 pb-8 px-4 scrollbar-hide scroll-smooth"
            style={{ scrollBehavior: "smooth" }}
          >
            {services.map((service, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-80 md:w-96 group"
                onClick={() => scrollToIndex(index)}
              >
                <div
                  className={`
                  bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl hover:shadow-2xl 
                  transition-all duration-500 transform hover:-translate-y-2 
                  border-2 ${
                    index === activeIndex
                      ? "border-emerald-300"
                      : "border-gray-100"
                  }
                  overflow-hidden cursor-pointer h-full flex flex-col
                `}
                >
                  {/* Image Container */}
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900/30 via-transparent to-transparent"></div>

                    {/* Icon Badge */}
                    <div className="absolute top-4 left-4">
                      <div
                        className={`w-12 h-12 rounded-xl ${service.bg} ${service.border} flex items-center justify-center shadow-lg`}
                      >
                        <div className="text-emerald-600">{service.icon}</div>
                      </div>
                    </div>

                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/20 via-transparent to-transparent"></div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6 flex-1 flex flex-col">
                    <div className="mb-4">
                      <div
                        className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold mb-3 ${service.bg} ${service.border}`}
                      >
                        <div
                          className={`w-2 h-2 rounded-full bg-gradient-to-r ${service.color}`}
                        ></div>
                        Premium Service
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">
                        {service.title}
                      </h3>
                      <p className="text-gray-600">{service.description}</p>
                    </div>

                    {/* Link Button */}
                    <div className="mt-auto pt-4 border-t border-gray-100">
                      <Link
                        to={service.link}
                        className="group/link inline-flex items-center justify-between w-full"
                      >
                        <span className="text-emerald-600 hover:text-emerald-800 font-semibold text-lg group-hover/link:underline transition-all duration-300">
                          Explore {service.title}
                        </span>
                        <span className="w-8 h-8 rounded-full bg-emerald-50 flex items-center justify-center group-hover/link:bg-emerald-100 transition-colors duration-300">
                          <ArrowRight className="w-4 h-4 text-emerald-600 group-hover/link:translate-x-1 transition-transform duration-300" />
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right Arrow */}
          {showRightArrow && (
            <button
              onClick={() => scroll("right")}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-6 md:translate-x-8 bg-white/90 backdrop-blur-sm shadow-2xl rounded-full p-3 z-20 hover:bg-white transition-all duration-300 group hover:scale-110 border border-gray-200"
              aria-label="Scroll right"
            >
              <ChevronRight className="w-6 h-6 text-gray-700 group-hover:text-emerald-600 transition-colors" />
            </button>
          )}
        </div>

        {/* Scroll Indicators */}
        <div className="flex flex-col items-center gap-4 mt-8">
          <div className="flex items-center gap-2">
            {services.map((_, index) => (
              <button
                key={index}
                onClick={() => scrollToIndex(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === activeIndex
                    ? "w-8 bg-gradient-to-r from-emerald-500 to-lime-500"
                    : "bg-gray-300 hover:bg-emerald-400"
                }`}
                aria-label={`Go to service ${index + 1}`}
              />
            ))}
          </div>
          <p className="text-sm text-gray-500 text-center">
            Discover all our premium services
          </p>
        </div>

        {/* Additional Services Info */}
        <div className="mt-16 md:mt-20 grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-emerald-600"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
              </svg>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Premium Quality</h4>
            <p className="text-gray-600 text-sm">
              Top-tier facilities and services
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-lime-50 to-emerald-50 flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-lime-600"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
              </svg>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Member Exclusive</h4>
            <p className="text-gray-600 text-sm">
              Services tailored for our community
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-emerald-600"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
              </svg>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">24/7 Support</h4>
            <p className="text-gray-600 text-sm">
              Always available for our members
            </p>
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-16 bg-gradient-to-r from-emerald-500 to-lime-500 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Experience Excellence at RGCC
          </h3>
          <p className="mb-6 max-w-2xl mx-auto text-emerald-100">
            Our services are designed to enhance your golfing experience and
            provide the ultimate in luxury and convenience.
          </p>
          <Link
            to="/membership"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full font-bold bg-white text-emerald-600 hover:bg-emerald-50 hover:scale-105 transition-all duration-300 shadow-lg"
          >
            <span>Become a Member</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services;
